import {NavigateFunction, useNavigate} from "react-router-dom";

const Utility = {
    "isEmpty": function (emptyObj: any) {
        return Object.keys(emptyObj).length === 0 && emptyObj.constructor === Object;
    },
    "formatDate": (inputDate: Date) => {
        if (!isNaN(inputDate.getTime())) {
            const year = inputDate.getFullYear().toString();
            const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
            const day = inputDate.getDate().toString().padStart(2, '0');

            return `${year}-${month}-${day}`;
        } else {
            return '';
        }
    },
    "formatDateTime": (inputDateTime: Date) => {
        if (!isNaN(inputDateTime.getTime())) {
            const year = inputDateTime.getFullYear().toString();
            const month = (inputDateTime.getMonth() + 1).toString().padStart(2, '0');
            const day = inputDateTime.getDate().toString().padStart(2, '0');
            const hour = inputDateTime.getHours().toString().padStart(2, '0');
            const minute = inputDateTime.getMinutes().toString().padStart(2, '0');

            return `${year}/${month}/${day} ${hour}:${minute}`;
        } else {
            return '';
        }
    },
    "formatDateTimeT": (inputDate: Date) => {
        if (!isNaN(inputDate.getTime())) {
            const year = inputDate.getFullYear().toString();
            const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
            const day = inputDate.getDate().toString().padStart(2, '0');
            const hour = String(inputDate.getHours()).padStart(2, "0"); // 時を2桁にパディング
            const min = String(inputDate.getMinutes()).padStart(2, "0"); // 分を2桁にパディング

            return `${year}-${month}-${day}T${hour}:${min}`;
        } else {
            return '';
        }
    },
    "formatDateTimeForGraphDisplay": (inputDate: Date) => {
        if (!isNaN(inputDate.getTime())) {
            const year = inputDate.getFullYear().toString();
            const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
            const day = inputDate.getDate().toString().padStart(2, '0');
            const hour = String(inputDate.getHours()).padStart(2, "0"); // 時を2桁にパディング
            const min = String(inputDate.getMinutes()).padStart(2, "0"); // 分を2桁にパディング

            return `${year}-${month}-${day} ${hour}:${min}`;
        } else {
            return '';
        }
    },

    "formatDateStr": function (dateString: string) {
        const inputDate = new Date(dateString);
        return this.formatDate(inputDate);
    },

    "formatDateStrGraph": function (dateString: string) {
        const inputDate = new Date(dateString);
        return this.formatDateTimeForGraphDisplay(inputDate);
    },

    "ReformatDate": function (inputDateString: string) {
        const parts = inputDateString.split('-');
        if (parts.length === 3) {
            const [year, month, day] = parts;
            return `${year}/${month}/${day}`;
        }
        return inputDateString; // 変換できない場合はそのまま返す
    },

    "ReformatDateGraph": function (inputDateTimeString: string) {
        const replaceDate = inputDateTimeString.replace('T', ' ');
        const parts = replaceDate.split('-');
        const [year, month, dayTime] = parts;
        return `${year}/${month}/${dayTime}`;
    },

    "redirectByAuthority" : function(navigate:NavigateFunction, authority:number, userId?:string, siteRecno?:string){
        switch (authority) {
            case 1:
                navigate('/topmenu', { state: { authority: authority } });
                break;
            case 2:
                navigate('/site_admin', { state: { authority: authority } });
                break;
            case 3:
            case 4:
                navigate(`/dashboard/${userId}/${siteRecno}`, { state: { authority: authority } });
                break;
            default:
                navigate('/', { state: { authority: authority } });
                break;
        }
    }
};
export default Utility;

